import React, { useState, useEffect } from 'react'
import { Box, Typography } from '@mui/material'
import styled from 'styled-components'
import moment from 'moment'

export const InfoCard = (props) => {
  const { data } = props
  const [day, date, curTime] = moment().format('dddd, MMMM Do YYYY,h:mm A').split(',')
  const [time, setTime] = useState(curTime)

  useEffect(() => {
    const intRef = setInterval(() => {
      const time = moment().format('h:mm A')
      setTime(time)
    }, 1000)
    return () => {
      clearInterval(intRef)
    }
  }, [])

  return (
    <Box bgcolor='#fff' borderRadius={3} display='flex' width='100%' height='100%'>
      <Box
        display='flex'
        justifyContent='space-between'
        width='100%'
        sx={{ flexDirection: { xs: 'column', sm: 'column', md: 'column', lg: 'row' } }}
      >
        <Box flex={2} display='flex' alignItems='center' justifyContent='center'>
          <StyledImage
            width='100%'
            height='100%'
            component='img'
            alt='Info Image'
            src={data?.imgSrc ? data?.imgSrc : '/wallpaper/Sea.jpg'}
            borderRadius={3}
          />
        </Box>

        <Box
          display='flex'
          flexDirection='column'
          width='100%'
          p={5}
          flex={1}
          boxSizing='border-box'
        >
          <Box mb={5}>
            <Typography variant='h4' sx={{ fontSize: { xs: '14px', sm: '14px' } }}>
              {time} {day}, {date}
            </Typography>
          </Box>
          {data?.name ? (
            <>
              <Typography variant='h4' sx={{ fontSize: { xs: '28px', sm: '32px' } }}>
                Hello,
              </Typography>
              <Typography variant='h4' sx={{ fontSize: { xs: '28px', sm: '32px' } }}>
                {data?.name}!
              </Typography>
            </>
          ) : (
            <Typography variant='h4' sx={{ fontSize: { xs: '28px', sm: '32px' } }}>
              Hello!
            </Typography>
          )}
          <Box mt={3}>
            <Typography variant='h4' sx={{ color: '#565656' }}>
              {data?.position}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

const StyledImage = styled(Box)`
  && {
    object-fit: cover;
    object-position: center;
  }
`
